<!--Copy right - © 2024 tecera gmbh-->
<script>
    import ResetPasswordForm from "../components/forms/ResetPasswordForm.svelte";
</script>

<svelte:head>
    <title>myBach | Passwort vergessen</title>
</svelte:head>

<div class="background-container">
    <ResetPasswordForm />
</div>
